import { TourStep } from 'src/types/tutorial';

export const mainTourSteps: TourStep[] = [
  {
    target: '[data-tour="dashboard"]',
    title: 'Welcome to Telix Lab!',
    content: 'This is your dashboard where you can see all your projects, recent activity, and quick stats. Let\'s take a quick tour to get you started.',
    placement: 'center',
  },
  {
    target: '[data-tour="menu-bar"]',
    title: 'Menu Bar',
    content: 'Use the menu bar to access all features: create projects, edit code, view simulations, manage modules, and more. Everything is organized for easy access.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="toolbar"]',
    title: 'Toolbar',
    content: 'The toolbar provides quick access to common actions like creating new projects, saving, running simulations, and toggling the theme.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="new-project"]',
    title: 'Create Your First Project',
    content: 'Click here to create a new project. You can start from scratch or use a template to get started quickly.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="flow-editor"]',
    title: 'Flow Editor',
    content: 'The Flow Editor lets you build robot applications visually by connecting nodes. It\'s perfect for beginners and experts alike.',
    placement: 'right',
  },
  {
    target: '[data-tour="simulation"]',
    title: '3D Simulator',
    content: 'Visualize and test your robots in realistic 3D environments. See how they move, interact with objects, and respond to sensors.',
    placement: 'right',
  },
  {
    target: '[data-tour="save"]',
    title: 'Save Your Work',
    content: 'Always remember to save your projects! Your work is automatically saved, but you can also manually save or export your projects.',
    placement: 'top',
  },
];

